import { ContactListWebPageResponseItem } from 'commons/types/contracts/api/bank/contactList'
import { Icon, IconName, IconSize } from 'ui/components/Icon'
import { TableActions, TableColumn } from 'ui/components/Table'
import { Tooltip } from 'ui/components/Tooltip'

import { CONTACTS_PATH } from '../../../../constants'

import { NameLink } from './styles'

export const columns = (
  onDelete: (item: ContactListWebPageResponseItem) => any
): TableColumn<ContactListWebPageResponseItem>[] => [
  {
    align: 'left',
    title: 'Name',
    render: (item) => (
      <NameLink to={`${CONTACTS_PATH}/${item.id}`} data-qa={`contact-name-link-${item.contactInfo.trim()}`}>
        {item.contactInfo}
        {item.isShared && (
          <Tooltip id={`shared${item.id}`} type="dark" content="Shared" event="hover">
            <Icon name={IconName.SHARED} size={IconSize.XS} />
          </Tooltip>
        )}
      </NameLink>
    )
  },
  {
    align: 'center',
    title: 'Email',
    key: 'email'
  },
  {
    align: 'center',
    title: 'Phone',
    key: 'phone'
  },
  {
    title: 'Actions',
    align: 'center',
    width: '50px',
    render: (item) => (
      <TableActions
        items={[
          {
            type: 'edit',
            url: `${CONTACTS_PATH}/${item.id}/edit`
          },
          {
            type: 'delete',
            onClick: () => onDelete(item)
          }
        ]}
      />
    )
  }
]
